











import { Component, Vue } from 'vue-property-decorator'
import request, { Response } from '@/helpers/requests'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


interface RequestPayload {
    pulsemAccountId: number|null;
    isAutoApprove: boolean|null;
    isAutoPost: boolean|null;
    postFrequency: string|number|null;
}


interface ResponsePayload extends Response {
    data: RequestPayload;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard
    }
})
export default class FacebookPostSettings extends Vue {
    locationValid = false
    pulsemAccountId: number|null = null
    isAutoApprove: boolean|null = null
    isAutoPost: boolean|null = null
    postFrequency: string|number|null = null

    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId,
            isAutoApprove: this.isAutoApprove,
            isAutoPost: this.isAutoPost,
            postFrequency: typeof this.postFrequency === 'string' ? parseInt(this.postFrequency) : this.postFrequency
        }
    }

    async loadSettings(): Promise<ResponsePayload> {
        return await request.post('/support/facebook-post-settings-load/load', {
            pulsemAccountId: this.pulsemAccountId
        }) as ResponsePayload
    }

    async onLocationChange(locationValid: boolean) {
        this.locationValid = locationValid
        if (this.locationValid) {
            const response = await this.loadSettings()
            this.isAutoApprove = response.data.isAutoApprove
            this.isAutoPost = response.data.isAutoPost
            this.postFrequency = response.data.postFrequency
        } else {
            this.isAutoApprove = null
            this.isAutoPost = null
            this.postFrequency = null
        }
    }

    onSuccess(status: boolean) {
        if (status) {
            this.pulsemAccountId = null
            this.isAutoApprove = null
            this.isAutoPost = null
            this.postFrequency = null
        }
    }
}
